<template>
    <div class="max-w-full mx-auto pb-10">
        <div class="pb-24 sm:pb-28 bg-gradient-to-br from-brand-500 via-brand-400 to-brand-300 wave-border"></div>
        <div class="max-w-7xl mx-auto px-2">
            <div class="-mt-12 sm:-mt-20 sm:flex sm:items-center sm:justify-between sm:space-x-5">
                <div class="flex relative z-20 items-center justify-between sm:space-x-5 w-full flex-col sm:flex-row">
                    <div class="flex flex-col sm:flex-row">
                        <avatar class="-mt-2 h-32 w-32 rounded-full ring-4 ring-white sm:h-40 sm:w-40" :src="user.profile_photo_url"></avatar>
                        <div class="flex z-20 sm:gap-3 flex-col sm:pl-6">
                            <div class="pt-2 sm:pt-0 text-brand sm:text-white text-xl sm:text-4xl sm:h-20 flex justify-center sm:justify-start items-center">{{ user.tag }}</div>
                            <div class="flex flex-col gap-1">
                                <div class="text-md text-gray-800">
                                    <!--<strong>{{ videos.length }}</strong> Challenges Completed-->
                                    <div class="max-w-2xl" v-text="user.bio"></div>
                                </div>
                                <a v-if="user.currentUser === user.username" href="/settings" class="text-blue-500 hover:text-blue-700 transition text-md">Edit Profile</a>
                            </div>
                        </div>
                    </div>
                    <div class="w-full items-center justify-center sm:w-auto py-3 sm:p-0">
                        <a :href="'/challenges/create/' + user.tag" class="flex justify-center w-full sm:w-auto bg-brand hover:bg-brand-400 transition text-white sm:text-xl rounded-lg px-6 py-4 sm:px-10 sm:py-5 font-bold sm:ring-8 ring-gray-50 uppercase">Challenge Me</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full mx-auto sm:px-6 sm:py-8">
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 sm:gap-6">
                <a :href="video.url" v-for="(video, index) in videos" :key="video.id" class="block relative aspect-w-9 aspect-h-16 sm:rounded-lg overflow-hidden bg-gray-300">
                    <img :src="video.frames[currentFrameIndices[index]]" alt="Video Thumbnails" class="w-full h-full object-cover" />
                    <!-- Play Icon and Video Title could be added here as needed -->
                    <!--<div class="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2 text-center">-->
                    <!--    {{ video.title || "Untitled Video" }}-->
                    <!--</div>-->
                </a>
            </div>
        </div>
    </div>
    <!--</app-layout>-->
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import JetDialogModal from "@/Jetstream/DialogModal"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import JetButton from "@/Jetstream/Button"
import Comments from "@/Comments/Comments"
import ImageModal from "@/Components/ImageModal"
import JetDropdown from "@/Jetstream/Dropdown"

export default {
    layout: AppLayout,

    components: { JetDropdown, ImageModal, Comments, AppLayout, JetDialogModal, JetSecondaryButton, JetButton },
    props: {
        user: Object,
    },

    created() {
        this.initializeVideos() // Set up the videos initially
        this.startTimelapse() // Start the timelapse when the component is created
    },

    mounted() {},

    computed: {
        videos() {
            if (this.user) {
                return this.user.videos
            }
        },
    },

    watch: {},

    data() {
        return {
            normalizedVideos: [],
            currentFrameIndices: [],
            timelapseInterval: null,
        }
    },

    methods: {
        // formatDateTime(date) {
        //     return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
        // },
        initializeVideos() {
            if (this.user && this.user.videos) {
                this.normalizedVideos = this.user.videos.map((video) => {
                    // Check if frames is an object and convert it to an array if necessary
                    if (!Array.isArray(video.frames)) {
                        video.frames = Object.keys(video.frames)
                            .sort((a, b) => a - b) // Sorting the keys before mapping to ensure order
                            .map((key) => video.frames[key])
                    }
                    return video
                })
                this.currentFrameIndices = new Array(this.normalizedVideos.length).fill(0)
            }
        },

        updateFrames() {
            this.currentFrameIndices = this.currentFrameIndices.map((currentIndex, i) => {
                return (currentIndex + 1) % this.normalizedVideos[i].frames.length
            })
        },

        startTimelapse() {
            this.timelapseInterval = setInterval(this.updateFrames, 1000) // Rotate frames every second
        },
    },

    beforeDestroy() {
        if (this.timelapseInterval) {
            clearInterval(this.timelapseInterval) // Clean up the interval when the component is destroyed
        }
    },
}
</script>

<style scoped>
@keyframes float {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}
.wave-border {
    clip-path: polygon(0 0, 100% 0, 100% 85%, 0% 100%);
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1)) brightness(110%);
    transition: 0.5s ease;
}
</style>
